import React from 'react';
import styled, { css } from 'styled-components';
import { cssSpacing, screenMdMax, screenXxsMax, Text } from '@spotify-internal/encore-web';
import { fadeInAnimation, DELAYS, withAnimationContext } from '../Animations';
import { ResponsiveHeadline } from './ResponsiveHeadline';
import { BodyText } from './BodyText';
import { TWO_COLUMN_MAX_WIDTH } from '../Components';
const gridStyles = css `
  display: grid;
  width: 100%;
  grid-template-columns: repeat(var(--columns), 1fr);
  column-gap: ${cssSpacing('looser-2')};

  // Common styles for all elements
  .eyebrow,
  .headline,
  .cta,
  .tagline,
  .paragraph {
    display: flex;
    grid-column: 1 / calc(var(--columns) + 1);

    @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
      grid-column: 1 / -1;
    }
  }

  .cta{
    @media (max-width: ${screenXxsMax}) {
      width: 100%;
      justify-content: center;
    }
  }

  // Specific styles for tagline and paragraph
  // they are 1 column shorter on larger screens
  .tagline,
  .paragraph {
    padding-top: ${cssSpacing('looser')};
    grid-column: 1 / var(--columns);

    @media (max-width: ${screenMdMax}) {
      grid-column: 1 / calc(var(--columns) + 1);
    }
  }

  // Specific styles for eyebrow and cta
  .eyebrow {
    padding-bottom: ${cssSpacing('tighter')};
  }
  .cta {
    padding-top: ${cssSpacing('looser-2')};
  }
`;
const flexStyles = css `
  display: flex;
  flex-direction: column;
`;
const AnimatedWrapper = withAnimationContext(styled.div `
  --columns: ${(props) => props.columns};
  ${(props) => (props.columns ? gridStyles : flexStyles)}

  & > *:nth-child(1) {
    ${fadeInAnimation(DELAYS.FIRST)};
  }
  & > *:nth-child(2) {
    ${fadeInAnimation(DELAYS.SECOND)};
  }
  & > *:nth-child(3) {
    ${fadeInAnimation(DELAYS.THIRD)};
  }
  & > *:nth-child(4) {
    ${fadeInAnimation(DELAYS.FOURTH)};
  }
`);
const FlexWrapper = styled.div `
  display: flex;
`;
export const PageSectionHeader = ({ eyebrow, headline, isTagline = false, tagline, paragraph, useLargeText = false, cta, columns, className, }) => {
    return (React.createElement(FlexWrapper, { className: className },
        React.createElement(AnimatedWrapper, { columns: columns },
            eyebrow && (React.createElement(Text, { variant: "bodyMedium", className: "eyebrow" }, eyebrow.toUpperCase())),
            headline && (React.createElement(ResponsiveHeadline, { headline: headline, useLargeText: useLargeText })),
            React.createElement(BodyText, { tagline: tagline, paragraph: paragraph, isTagline: isTagline }),
            cta && React.createElement("div", { className: "cta" }, cta))));
};
